import type { Passkey } from 'models';
import { useTranslation } from 'react-i18next';
import { Button, Col, Flex, Icon, Row, Text } from 'ui';

type P = {
  onDelete: (passkey: Passkey) => void;
  passkey: Passkey;
};

const PasskeyItem = ({ onDelete, passkey }: P) => {
  const { t } = useTranslation();

  return (
    <Row align="middle" className="passkey-item" justify="space-between">
      <Col>
        <Flex vertical>
          <Text type="title" weight="bold">
            {passkey.name}
          </Text>
          <Text type="secondary">
            {t('Updated')}:{' '}
            {t('dateFormats.dateTime', {
              date: new Date(passkey.updatedAt),
            })}
          </Text>
        </Flex>
      </Col>
      <Col>
        <Flex justify="end">
          <Button
            danger
            icon={<Icon icon="delete-2-line" />}
            onClick={() => {
              onDelete(passkey);
            }}
            type="link-primary"
          />
        </Flex>
      </Col>
    </Row>
  );
};

export default PasskeyItem;
